/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable new-cap */
import React, { Fragment, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Button, Alert, notification,
} from 'antd';
import {
} from '@ant-design/icons';
import H3FormInput from '@Uilib/h3FormInput';
import { QUANTITY } from '@Apis/constants';
import { v4 as uuidv4 } from 'uuid';
import jobWorkActions from '@Actions/production/jobWorkActions';
import './style.scss';

/**
 *
 */
function CompleteProcessing ({
  user, items, callback, processJwMaterialCompleteLoading,
  processingCompletionType, processJwMaterialComplete }) {

  const [rawMaterials, setRawMaterials] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const rawMaterialColumns = [
    {
      title: 'Product',
      width: '250px',
      render: (item) => (
        <Fragment>
          {
            item?.is_item_row ? (<Fragment>
              <Link to={`/inventory/product/view/${item.product_sku_id}`} target="_blank">
                {`#${item?.internal_sku_code}`}
              </Link>
              {` ${item?.ref_product_code ? `${item?.ref_product_code} - ` : ''} ${item?.product_sku_name}`}
            </Fragment>) : `${item?.custom_batch_number}`
          }
        </Fragment>
      ),
      onCell: (item) => {
        if (item?.is_item_row) {
          return { colSpan: 5 };
        }
        return {};
      },
    },
    {
      title: 'Sent for Processing',
      render: (record) => (
        <Fragment>
          {QUANTITY(record?.required_quantity, record?.uom_info?.precision)}
          &nbsp;{record?.uom_info?.uqc?.toProperCase()}
        </Fragment>
      ),
      onCell: (item) => {
        if (item?.is_item_row) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: 'Pending',
      render: (item) => (
        <Fragment>
          {QUANTITY(item?.pending_qty || 0, item?.uom_info?.precision)}&nbsp;{item?.uom_info?.uqc?.toProperCase()}
        </Fragment>
      ),
      onCell: (item) => {
        if (item?.is_item_row) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: 'Completed',
      render: (record) => (
        <Fragment>
          <H3FormInput
            value={record.completed_qty}
            type="number"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            name="quantity is more than available quantity"
            onChange={(e) => {
              setRawMaterials((prevRawMaterials) => {
                const updatedRawMaterials = prevRawMaterials.map((item) => {
                  if (item.key === record.key) {
                    return {
                      ...item,
                      completed_qty: e.target.value,
                    };
                  }
                  return item;
                });
                return updatedRawMaterials;
              });
            }}
          />
        </Fragment>
      ),
      onCell: (item) => {
        if (item?.is_item_row) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: 'Rework',
      render: (record) => (
        <Fragment>
          <H3FormInput
            value={record.rework_qty}
            type="number"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            name="quantity is more than available quantity"
            onChange={(e) => {
              setRawMaterials((prevRawMaterials) => {
                const updatedRawMaterials = prevRawMaterials.map((item) => {
                  if (item.key === record.key) {
                    return {
                      ...item,
                      rework_qty: e.target.value,
                    };
                  }
                  return item;
                });
                return updatedRawMaterials;
              });
            }}
          />
        </Fragment>
      ),
      onCell: (item) => {
        if (item?.is_item_row) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
  ];
  

  useEffect(() => {
    const processingLines = [];
    if (items?.length > 0) {
      items?.forEach((item) => {
        processingLines.push({
          key: uuidv4(),
          internal_sku_code: item?.internal_sku_code,
          mo_fg_id: item?.mo_fg_id,
          mo_line_id: item?.mo_line_id,
          prl_processing_material_id: 1,
          product_sku_id: item?.product_sku_id,
          product_sku_name: item?.product_sku_name,
          production_route_line_id: item?.production_route_line_id,
          ref_product_code: item?.ref_product_code,
          tenant_id: item?.tenant_id,
          tenant_product_id: item?.tenant_product_id,
          uom_info: item?.uom_info, 
          is_item_row: true,
        });
        item?.wip_ledger?.forEach((ledger) => {
          processingLines.push({
            ...ledger,
            key: uuidv4(),
            is_item_row: false,
            required_quantity: item?.wip_details?.total_qty_sent_for_processing,
            pending_qty: processingCompletionType === 'PENDING' ? ledger?.pending_qty : ledger?.rework_qty,
            completed_qty: processingCompletionType === 'PENDING' ? ledger?.pending_qty : ledger?.rework_qty,
            rework_qty: 0,
          });
        })
      })
      setRawMaterials(processingLines);
    }
    
  }, [items])


  /**
   *
   */
  const addRawMaterial = () => {
    setFormSubmitted(true)
    if(isDataValid()) { 
      const wipEntries = [];
      rawMaterials?.filter((ledger) => !ledger?.is_item_row)?.map((ledgerLine) => {
        wipEntries.push({
          wip_ledger_id: Number(ledgerLine?.wip_ledger_id),
          completed_qty: Number(ledgerLine?.completed_qty),
          rework_qty: Number(ledgerLine?.rework_qty || 0),
        });
      });
      processJwMaterialComplete({
        processing_materials: wipEntries,
      }, () => {
        setHasError(false); 
        setFormSubmitted(false);
        callback();
      })
    }
  }

  const isDataValid = () => {
    let isValid = true;
    rawMaterials?.filter((ledger) => !ledger?.is_item_row)?.map((ledgerLine) => {
      const qtyToUpdate = (Number(ledgerLine?.completed_qty ?? 0) + Number(ledgerLine?.rework_qty ?? 0));
      if(qtyToUpdate <= 0 || qtyToUpdate > Number(ledgerLine?.pending_qty)) {
        isValid = false;
      }
    });
    if(!isValid) {
      setHasError(true);
      notification.open({ message: 'Please enter valid quantities', placement: 'top', type: 'error', duration: 4 });
    }
    return isValid;
  }

  
  return (
    <div>
      <div className="mg-top-10">
        <Table
          showHeader
          size="small"
          columns={rawMaterialColumns?.filter((item) => !item?.hidden)}
          dataSource={rawMaterials}
          pagination={false}
          scroll={{ x: true }}
          bordered
          rowClassName={(record) => (!record?.is_item_row && ((Number(record?.completed_qty ?? 0) + Number(record?.rework_qty ?? 0)) > Number(record?.pending_qty ?? 0))  ? 'row-warning' : '')}
          loading={processJwMaterialCompleteLoading}
        />
        {
        formSubmitted && hasError && (
          <Alert
            type="error"
            message={`Completed + Rework quantity should be less than ${processingCompletionType?.toProperCase()} quantity`}
            showIcon
            style={{ marginTop: '10px' }}
          />
        )
      }
      </div>
      <div className="custom-drawer__footer" style={{ width: '905px' }}>
        <Button
          type="primary"
          onClick={() => addRawMaterial()}
          loading={processJwMaterialCompleteLoading}
          disabled={processJwMaterialCompleteLoading}
        >
            Complete Processing
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, JobWorkReducers,
}) => ({
  user: UserReducers.user,
  processJwMaterialCompleteLoading: JobWorkReducers.processJwMaterialCompleteLoading,
});

const mapDispatchToProps = (dispatch) => ({
  processJwMaterialComplete: (payload, callback) => dispatch(jobWorkActions.processJwMaterialComplete(payload, callback)),
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CompleteProcessing));
